import type { DefaultLayoutTranslations } from "@vidstack/react/player/layouts/default";

export function getVidstackTranslations(
  getLabel: (key: string, fallback?: string) => string,
): DefaultLayoutTranslations {
  return {
    "Caption Styles": getLabel("vidstack_caption_styles", "Untertitel-Stile"),
    "Captions look like this": getLabel(
      "vidstack_captions_look_like_this",
      "So sehen Untertitel aus",
    ),
    "Closed-Captions Off": getLabel(
      "vidstack_closed_captions_off",
      "Untertitel aus",
    ),
    "Closed-Captions On": getLabel(
      "vidstack_closed_captions_on",
      "Untertitel an",
    ),
    "Display Background": getLabel(
      "vidstack_display_background",
      "Hintergrund anzeigen",
    ),
    "Enter Fullscreen": getLabel(
      "vidstack_enter_fullscreen",
      "Vollbild aktivieren",
    ),
    "Enter PiP": getLabel("vidstack_enter_pip", "Bild-in-Bild aktivieren"),
    "Exit Fullscreen": getLabel(
      "vidstack_exit_fullscreen",
      "Vollbild verlassen",
    ),
    "Exit PiP": getLabel("vidstack_exit_pip", "Bild-in-Bild verlassen"),
    "Google Cast": getLabel("vidstack_google_cast", "Google Cast"),
    "Keyboard Animations": getLabel(
      "vidstack_keyboard_animations",
      "Tastaturanimationen",
    ),
    "Seek Backward": getLabel("vidstack_seek_backward", "Zurückspulen"),
    "Seek Forward": getLabel("vidstack_seek_forward", "Vorspulen"),
    "Skip To Live": getLabel(
      "vidstack_skip_to_live",
      "Zum Live-Inhalt springen",
    ),
    "Text Background": getLabel("vidstack_text_background", "Text-Hintergrund"),

    Accessibility: getLabel("vidstack_accessibility", "Barrierefreiheit"),
    AirPlay: getLabel("vidstack_airplay", "AirPlay"),
    Announcements: getLabel("vidstack_announcements", "Mitteilungen"),
    Audio: getLabel("vidstack_audio", "Audio"),
    Auto: getLabel("vidstack_auto", "Auto"),
    Boost: getLabel("vidstack_boost", "Verstärken"),
    Captions: getLabel("vidstack_captions", "Untertitel"),
    Chapters: getLabel("vidstack_chapters", "Kapitel"),
    Color: getLabel("vidstack_color", "Farbe"),
    Connected: getLabel("vidstack_connected", "Verbunden"),
    Connecting: getLabel("vidstack_connecting", "Verbindung wird hergestellt"),
    Continue: getLabel("vidstack_continue", "Fortfahren"),
    Default: getLabel("vidstack_default", "Standard"),
    Disabled: getLabel("vidstack_disabled", "Deaktiviert"),
    Disconnected: getLabel("vidstack_disconnected", "Getrennt"),
    Download: getLabel("vidstack_download", "Herunterladen"),
    Family: getLabel("vidstack_family", "Schriftfamilie"),
    Font: getLabel("vidstack_font", "Schriftart"),
    Fullscreen: getLabel("vidstack_fullscreen", "Vollbild"),
    LIVE: getLabel("vidstack_live", "LIVE"),
    Loop: getLabel("vidstack_loop", "Wiederholen"),
    Mute: getLabel("vidstack_mute", "Stumm"),
    Normal: getLabel("vidstack_normal", "Normal"),
    Off: getLabel("vidstack_off", "Aus"),
    Opacity: getLabel("vidstack_opacity", "Deckkraft"),
    Pause: getLabel("vidstack_pause", "Pause"),
    PiP: getLabel("vidstack_pip", "BiB"),
    Play: getLabel("vidstack_play", "Abspielen"),
    Playback: getLabel("vidstack_playback", "Wiedergabe"),
    Quality: getLabel("vidstack_quality", "Qualität"),
    Replay: getLabel("vidstack_replay", "Nochmal abspielen"),
    Reset: getLabel("vidstack_reset", "Zurücksetzen"),
    Seek: getLabel("vidstack_seek", "Springen"),
    Settings: getLabel("vidstack_settings", "Einstellungen"),
    Shadow: getLabel("vidstack_shadow", "Schatten"),
    Size: getLabel("vidstack_size", "Größe"),
    Speed: getLabel("vidstack_speed", "Geschwindigkeit"),
    Text: getLabel("vidstack_text", "Text"),
    Track: getLabel("vidstack_track", "Spur"),
    Unmute: getLabel("vidstack_unmute", "Ton an"),
    Volume: getLabel("vidstack_volume", "Lautstärke"),
  };
}
